import { render, staticRenderFns } from "./CertificateLookupList.vue?vue&type=template&id=2efe5540&scoped=true"
import script from "./CertificateLookupList.vue?vue&type=script&lang=js"
export * from "./CertificateLookupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efe5540",
  null
  
)

export default component.exports